import React, { useState } from "react";
import { formatTime } from "../../utilities";
import useApiMutation from "../../hooks/useApiMutation";
import { sendToLaravelServer } from "../../utilities/service";
import { toast } from "react-toastify";
import Grid from "@mui/material/Grid2";
import OtpInput from "./OtpInput";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { Timer } from "@phosphor-icons/react";
import { useForm } from "react-hook-form";
import { OTPSchema } from "../../utilities/schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../hooks/AuthContext";
import { useEffect } from "react";

function OTPForm({
  handleResendOtp,
  cancelHandler,
  loginData,
  setShowWelcomeScreen,
  otpForm,
}) {
  const { setUser } = useAuth();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(30);
  const [resendDisabled, setResendDisabled] = useState(timer > 0);
  const [loading, setLoading] = useState(false);
  const [hasVerified, setHasVerified] = useState(false);

  const {
    mutate,
    isPending,
    error,
    data: customerData,
  } = useApiMutation({
    mutationFn: (param) => sendToLaravelServer(param),
    options: {
      onSuccess: (data) => {
        if (!data?.error) {
          toast.success(data?.message);
          localStorage.setItem("mobileNo", data.data?.customer_mobile);
          setUser((prev) => ({ ...prev, ...data.data }));
          setShowWelcomeScreen((prev) => true);
          cancelHandler(true);
        } else {
          toast.error(data?.message);
        }
      },
      onError: (error) => {
        toast.error(error?.message);
        console.error("Error creating product:", error);
        cancelHandler();
      },
    },
  });
  const verifyOtp = (otp) => {
    setLoading(true);
    if (otp) {
      const code = otp;
      confirmationResult
        .confirm(code)
        .then(async (result) => {
          // User signed in successfully.
          const user = result.user;
          const idToken = await user?.getIdToken();
          localStorage.setItem("fb_token", idToken);
          const verifyParms = {
            mobile: loginData?.mobile,
            name: loginData?.name,
            // fcm_token: fcm?.token,
            fb_token: idToken,
          };
          mutate(verifyParms);
        })
        .catch((error) => {
          if (error?.message?.includes("auth/invalid-verification-code")) {
            toast.error("Invalid OTP");
          } else {
            toast.error(error.message);
          }
          console.log(error.message);
        })
        .finally(() => setLoading(false));
    }
  };
  useEffect(() => {
    if (otp.length < 6) {
      setHasVerified(false);
    }
  }, [otp]);

  useEffect(() => {
    let interval;

    if (otpForm) {
      if (timer > 0) {
        interval = setInterval(() => {
          setTimer((prevTimer) => prevTimer - 1);
        }, 1000);
        setResendDisabled(true);
      } else {
        clearInterval(interval);
        setResendDisabled(false);
      }

      // Trigger OTP verification only once
      if (otp.length === 6 && !hasVerified) {
        setHasVerified(true);
        verifyOtp(otp);
      }

      return () => clearInterval(interval);
    }
  }, [timer, otpForm, otp, hasVerified]);
  return (
    <Grid size={12} sx={{ width: "100%" }}>
      <OtpInput length={6} onChange={setOtp} otp={otp} />
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        {/* Timer Section */}
        <Box display="flex" flexDirection="row" alignItems="center">
          <Timer width={18} height={18} />
          <Typography variant="body2" sx={{ fontWeight: 600, marginLeft: 1 }}>
            {formatTime(timer)}
          </Typography>
        </Box>

        {/* Resend OTP Button */}
        <Button
          onClick={handleResendOtp}
          disabled={resendDisabled}
          sx={{
            marginTop: 1,
            padding: "10px",
            fontSize: "14px",
            fontWeight: 600,
            color: resendDisabled ? "gray" : "primary.main",
            textTransform: "none",
          }}
        >
          Resend OTP
        </Button>
      </Box>
      <Button
        sx={{ width: "100%", height: "48px", mt: 1 }}
        variant="contained"
        disabled={otp?.length < 6 || loading}
        onClick={() => verifyOtp(otp)}
        id="otp-submit-button"
      >
        {loading ? (
          <CircularProgress color="white" size="21px" />
        ) : (
          "Verify OTP"
        )}
      </Button>
    </Grid>
  );
}

export default OTPForm;
